// extracted by mini-css-extract-plugin
export default {"container":"Goals_container__PZOCN","allGoalContent":"Goals_allGoalContent__aSYL7"};